import { render, staticRenderFns } from "./AboutContraindications.vue?vue&type=template&id=a3b22f7e&scoped=true"
import script from "./AboutContraindications.vue?vue&type=script&lang=js"
export * from "./AboutContraindications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b22f7e",
  null
  
)

export default component.exports